import apiData from "lib/stores/apiData";

const sortDetailsPaneTableItems = (a, b, sortTableBy, sortTableOrder, activeYear) => {
  switch (sortTableBy) {
    case "country":
      return sortCountry(a, b, sortTableOrder, activeYear);
    case "focus":
      return sortFocus(a, b, sortTableOrder, activeYear);
    case "prev":
      return sortPrev(a, b, sortTableOrder, activeYear);
    case "vuln":
      return sortVuln(a, b, sortTableOrder, activeYear);
    case "gov resp":
      return sortGov(a, b, sortTableOrder, activeYear);
    default:
      if (a.name < b.name) return -1;
      return 1;
  }
};

const sortCountry = (a, b, sortTableOrder, activeYear) => {
  if (sortTableOrder === "asc") {
    if (a.name < b.name) return -1;
    return 1;
  } else {
    if (a.name > b.name) return -1;
    return 1;
  }
};

const sortFocus = (a, b, sortTableOrder, activeYear) => {
  if (sortTableOrder === "asc") {
    if (a.documents_count > b.documents_count) return -1;
    return 1;
  } else {
    if (a.documents_count < b.documents_count) return -1;
    return 1;
  }
};

const sortPrev = (a, b, sortTableOrder, activeYear) => {
  if (sortTableOrder === "asc") {
    if (a[activeYear].prevalence > b[activeYear].prevalence) return -1;
    return 1;
  } else {
    if (a[activeYear].prevalence < b[activeYear].prevalence) return -1;
    return 1;
  }
};

const sortVuln = (a, b, sortTableOrder, activeYear) => {
  if (sortTableOrder === "asc") {
    if (a[activeYear].vulnerability > b[activeYear].vulnerability) return -1;
    return 1;
  } else {
    if (a[activeYear].vulnerability < b[activeYear].vulnerability) return -1;
    return 1;
  }
};

const sortGov = (a, b, sortTableOrder, activeYear) => {
  const nullGovResponseValue = [];
  apiData.countriesMap.forEach(country => {
    if (!country[activeYear].govresponse) {
      nullGovResponseValue.push(country.id);
    }
  });
  if (sortTableOrder === "asc") {
    if (nullGovResponseValue.includes(a.id)) return 1;
    if (a[activeYear].govresponse > b[activeYear].govresponse) return -1;
    return 1;
  } else {
    if (nullGovResponseValue.includes(a.id)) return 1;
    if (a[activeYear].govresponse < b[activeYear].govresponse) return -1;
    return 1;
  }
};

export default sortDetailsPaneTableItems;
